import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=9f006242"
import script from "./ChangePwd.vue?vue&type=script&lang=js"
export * from "./ChangePwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports